import { gql } from "apollo-angular";

export const CREATE_SW_COVERAGE_MUTATION = gql`mutation configuratorCreateSoftwareVersionCoverage($SoftwareVersionCoverage: SoftwareVersionCoverageInput) {
    configuratorCreateSoftwareVersionCoverage(SoftwareVersionCoverage: $SoftwareVersionCoverage) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const UPDATE_SW_COVERAGE_MUTATION = gql`mutation configuratorUpdateSoftwareVersionCoverage($SoftwareVersionCoverage: SoftwareVersionCoverageInput) {
    configuratorUpdateSoftwareVersionCoverage(SoftwareVersionCoverage: $SoftwareVersionCoverage) {
        responseMessages
        returnValue
        success
    }
  }
  `
  

export const DELETE_SW_COVERAGE_MUTATION = gql`mutation configuratorDeleteSoftwareVersionCoverage($Uid: String!) {
    configuratorDeleteSoftwareVersionCoverage(Uid: $Uid)
  }
  `
  